var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.scenario && _vm.scenario.all_price_keys.length > 1
    ? _c(
        "el-form",
        {
          staticClass: "form",
          attrs: {
            "label-position": _vm.formLabelPosition,
            "label-width": "250px"
          }
        },
        [
          _c("div", { staticClass: "heading" }, [
            _c("h3", [_vm._v("Please select your players")])
          ]),
          _vm._v(" "),
          _c(
            "el-alert",
            {
              staticClass: "players-alert",
              attrs: {
                type: _vm.playersAlertType,
                closable: false,
                "show-icon": ""
              }
            },
            [
              _c("template", { slot: "title" }, [
                _vm._v("\n      You have selected\n      "),
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.selectedPlayers) +
                      " out of " +
                      _vm._s(_vm.totalPlayers)
                  )
                ]),
                _vm._v(
                  "\n      players required to complete your booking\n    "
                )
              ])
            ],
            2
          ),
          _vm._v(" "),
          _vm._l(_vm.scenario.all_price_keys, function(pk) {
            return _c(
              "el-form-item",
              { attrs: { label: pk.description } },
              [
                _c("el-input-number", {
                  key: pk.id,
                  attrs: {
                    min: 0,
                    value: _vm.selectedPriceKeys[pk.id],
                    max:
                      _vm.selectedPlayers + _vm.peoplePerPriceKey(pk.id) >
                      _vm.totalPlayers
                        ? _vm.selectedPriceKeys[pk.id]
                        : 100
                  },
                  on: {
                    input: function($event) {
                      return _vm.setPriceKeyQty($event, pk)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.selectedPriceKeys[pk.id]
                  ? _c(
                      "span",
                      { staticClass: "pk-amount" },
                      [
                        _c("i18n-n", {
                          attrs: {
                            value: pk.value * _vm.selectedPriceKeys[pk.id],
                            format: "currency"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }